
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import { useI18n } from 'vue-i18n/index';
  import CustomDatePicker from '@/components/search/CustomDatePicker.vue';

  export default defineComponent({
    name: 'brokers-accounts-widget',
    props: {
      widgetClasses: String,
    },
    components: {
      CustomDatePicker,
    },
    async setup() {
      const { t, te } = useI18n();
      const loading = ref(true);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const totalBrokersAccounts = ref(0);
      const totalBrokersAccountsChangePercentage = ref(0);

      const store = useStore();
      await store.dispatch(Actions.GET_BROKERS_ACCOUNTS);
      const data = computed(() => store.getters.brokersAccountsDashboard);
      const customDateFrom = ref('');
      const customDateTo = ref('');
      const showDatePicker = ref(false);

      totalBrokersAccounts.value =
        data.value.data.accountsSummary.totalBrokersAccounts;
      totalBrokersAccountsChangePercentage.value =
        data.value.data.accountsSummary.totalBrokersAccountsChangePercentage;
      loading.value = false;
      const selectedPeriod = ref('last-7-days');

      const showCustomDatePicker = () => {
        showDatePicker.value = true;
        selectedPeriod.value = 'custom';
      };

      const applyCustomDates = async () => {
        if (!customDateFrom.value || !customDateTo.value) {
          alert('Please select both dates');
          return;
        }
        showDatePicker.value = false;
        await selectPeriod('custom');
      };

      const selectPeriod = async (period: string) => {
        loading.value = true;

        selectedPeriod.value = period;
        const obj = {
          dateRange: period,
          showTrend: false,
          dateFrom: '',
          dateTo: '',
        };

        if (period === 'custom' && customDateFrom.value && customDateTo.value) {
          obj.dateFrom = customDateFrom.value;
          obj.dateTo = customDateTo.value;
        }

        await store.dispatch(Actions.GET_BROKERS_ACCOUNTS, obj);
        totalBrokersAccounts.value =
          data.value.data.accountsSummary.totalBrokersAccounts;

        totalBrokersAccountsChangePercentage.value =
          data.value.data.accountsSummary.totalBrokersAccountsChangePercentage;
        loading.value = false;
        reinitializeComponents();
      };

      const textColor = computed(() => {
        if (totalBrokersAccountsChangePercentage.value > 0) return '#28a745';
        if (totalBrokersAccountsChangePercentage.value < 0) return '#dc3545';
        return '#6c757d';
      });

      const arrowSrc = computed(() => {
        if (totalBrokersAccountsChangePercentage.value > 0)
          return '/media/icons/dash/up.png';
        if (totalBrokersAccountsChangePercentage.value < 0)
          return '/media/icons/dash/down.png';
        return '';
      });

      return {
        textColor,
        arrowSrc,
        totalBrokersAccounts,
        totalBrokersAccountsChangePercentage,
        data,
        loading,
        selectedPeriod,
        selectPeriod,
        translate,
        showCustomDatePicker,
        customDateFrom,
        customDateTo,
        showDatePicker,
        applyCustomDates,
      };
    },
  });
